import { SkeletonBox } from '@/components';
import { Box } from '@palmetto/palmetto-components';

export const LeadManagementLoading = ({ rows = 10 }: { rows?: number }) => (
  <Box direction="column" childGap="xs">
    {Array.from({ length: rows }).map((_, index) => (
      <Box key={index} direction="row" alignItems="center" childGap="md">
        <SkeletonBox width="25%" height="40px" />
        <SkeletonBox width="15%" height="40px" />
        <SkeletonBox width="15%" height="40px" />
        <SkeletonBox width="15%" height="40px" />
        <SkeletonBox width="20%" height="40px" />
      </Box>
    ))}
  </Box>
);
